// Shipping discount (Diskon Ongkir) for the checkout. Mirrors server/helpers/orderShippingResolver.js
// so the buyer sees the same cut the order stores.

// The cut never exceeds the shipping price, and a percentage cut never exceeds the seller cap (Maksimal Potongan).
// A missing or non-positive cap keeps the uncapped behaviour of existing products.
export function getShippingDiscountAmount (shippingDiscount, shippingPrice) {
  const price = Math.max(Number(shippingPrice) || 0, 0)
  const discountValue = Math.max(Number(shippingDiscount && shippingDiscount.value) || 0, 0)

  if (!shippingDiscount || shippingDiscount.type !== 'percentage') {
    return Math.min(discountValue, price)
  }

  const percentageDiscount = Math.min((price * discountValue) / 100, price)
  const maxValue = shippingDiscount.maxStatus ? Number(shippingDiscount.maxValue) || 0 : 0

  return maxValue > 0 ? Math.min(percentageDiscount, maxValue) : percentageDiscount
}

// Picks the discount config for the buyer's payment method. shippingCOD only applies when the seller keeps
// separate COD/NON-COD settings (same rule as the server), so stale shippingCOD values never reach the checkout.
export function getShippingDiscountConfig (data, payment) {
  if (!data) return undefined

  const useCodConfig = payment === 'COD' && data.isPaymentTypeHaveDifferentValue && data.shippingCOD
  return useCodConfig ? data.shippingCOD.shippingDiscount : data.shippingDiscount
}
